<form class="form-section form-section-health" #promptFormEl [formGroup]="promptForm" (ngSubmit)="onSave()">
    <div class="header">
        <h2 class="ion-text-center">Add A Message</h2>
    </div>
    <div class="content">
        <div class="form-row message">
            <mat-form-field class="message" appearance="outline" class="large" floatLabel="always">
                <textarea matInput required formControlName="message"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="button-container">
        <ion-button expand="block" shape="round" size="large" class="action-btn" type="submit">
            Done
        </ion-button>
    </div>
</form>